var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiningDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.577,
    height: 64.437,
    viewBox: "0 0 63.577 64.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 63.577,
    height: 64.436,
    fill: "#1e1e1e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M31.541,145.093l-.713-.421c-9.56-11.334-20.024-21.953-29.555-33.3-1.7-2.023-1.7-1.882,0-3.9,2.886-3.438,6.441-7.669,9.564-10.823a2.465,2.465,0,0,1,1.063-.825l39.215-.06c.791-.076,1.145.392,1.632.884,3.6,3.636,6.768,8.095,10.377,11.771,1.1,1.143-.06,2.059-.813,2.956-9.546,11.369-20.021,22.01-29.606,33.351l-.662.374ZM28.9,98.278H14.552l5.477,8.936Zm20.135,0H34.687l8.87,8.936ZM17.572,108.22l-5.6-9.058L4.107,108.22Zm23.155,0-8.981-9.052-8.889,9.052Zm18.751,0-7.865-9.058-5.6,9.058Zm-40.585,2.517H4.233l24.916,28.189Zm40.459,0H21.6l10.257,27.937,7.417-20.016a1.214,1.214,0,0,1,2.345.448c-1.834,6.48-4.986,12.8-6.972,19.214-.035.114-.169.473-.023.482Z",
    transform: "translate(0 -80.657)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M194.269.028A1.336,1.336,0,0,1,195.817,1.2a45.234,45.234,0,0,1-.011,6.665,1.26,1.26,0,0,1-2.512-.115c-.246-2.044.183-4.568.01-6.666a1.559,1.559,0,0,1,.965-1.052",
    transform: "translate(-162.763 0)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M237.245,29.477a1.234,1.234,0,0,1,1.35,1.978,65.11,65.11,0,0,1-4.773,4.791,1.258,1.258,0,0,1-1.757-1.757c1-.715,4.325-4.816,5.18-5.012",
    transform: "translate(-195.295 -24.791)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M126.171,29.482a1.424,1.424,0,0,1,1.159.163l5.012,5.18a1.234,1.234,0,0,1-1.978,1.349,54.145,54.145,0,0,1-4.664-4.648c-.515-.723-.477-1.8.471-2.044",
    transform: "translate(-105.611 -24.79)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M260.9,206.756c1.232,1.2-.969,3.121-1.973,1.533a1.262,1.262,0,0,1,1.973-1.533",
    transform: "translate(-217.952 -173.863)",
    fill: "#1e1e1e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiningDiamondIcon);
export default __webpack_public_path__ + "static/media/shining-diamond-icon.2321101ccdbd46a06beb64f6ea2bcd65.svg";
export { ForwardRef as ReactComponent };